import {BOUNDING_BOX_PARAMS} from './map';

const RegionParams = ['region', 'regionId'];
const mockParams = ['mock'];
const modalParams = ['modal'];
const pinnedPropertyParams = ['availability.end', 'availability.start'];
const globalizationParams = ['gx-locale', 'cur']; // after this params are set via header and page is reloaded, we don't need them anymore

export const DEFAULT_PARAMS_TO_CLEAR = [
    ...globalizationParams,
    ...mockParams,
    ...modalParams,
    ...pinnedPropertyParams
];

export const CLEAR_LOCATION_PARAMS = [
    ...BOUNDING_BOX_PARAMS,
    ...RegionParams,
    'searchTermUuid'
];
